// extracted by mini-css-extract-plugin
export default {"button":"Button_button__emA1i","icon":"Button_icon__8ks8k","inversive":"Button_inversive__FufDd","backing":"Button_backing__TQAyc"};